module.exports = __webpack_public_path__ + "e2cffbdc.svg";